import React, { useContext } from 'react';
import { BazaarVoiceContext } from '@rsc/contexts';
import { formatReviewSku } from '@rsc/utils';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

import './index.css';

interface Props {
  sku: string;
}

const BazaarVoiceContainer = ({ sku }: Props) => {
  // @ts-expect-error until context is converted to TS
  const { showBazaarVoice } = useContext(BazaarVoiceContext);
  const { locale } = useUiComponentsInternationalContext();

  // Only skip rendering if showBazaarVoice explicitly returns false
  if (showBazaarVoice(locale) === false) {
    return null;
  }

  return (
    <div id={`BVRRInlineRating-${formatReviewSku(sku)}`}>
      <div
        data-bv-show="reviews"
        data-bv-product-id={formatReviewSku(sku)}
        data-bv-seo="false"
      />
      <div
        data-bv-show="questions"
        data-bv-product-id={formatReviewSku(sku)}
        data-bv-seo="false"
      />
    </div>
  );
};

export default BazaarVoiceContainer;
